import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { PersonalUebersicht } from '../../types/abteilung';

import { FormatPipe } from '@softline/ui-core';
@Component({
  selector: 'soft-mitarbeiter-card',
  imports: [CommonModule,
    FormatPipe],
  templateUrl: './mitarbeiter-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mitarbeiter-card.component.css'] })
export class MitarbeiterCardComponent implements OnInit {
  @Input() mitarbeiter!: PersonalUebersicht;
  @Input() selected = false;
  @Input() mode: 'selection' | 'display' = 'display';
  @Output() tapped = new EventEmitter<void>();

  constructor() {
    //
  }

  ngOnInit(): void {
    //
  }
}
